import { Contest, ContestDetailResponse, ContestStatus, Points } from "@jnext/ts-axios-contestformat";
import moment from "moment";
const momentTimeZone = require('moment-timezone');
import { DEFAULT_FORMAT_DATE } from ".";

export const getContestStatusColor = (status: ContestStatus | undefined, translate: (str: string, params?: Record<string, any>) => string) => {
    const statusCode = `CONTEST_STATUS_COLOR_${status}`;
    const backgroundColor = translate(statusCode);

    return {
        color: "#FFF",
        backgroundColor: backgroundColor || "#888",
    };
};

const getCountdown = (endDate: string) => {
    const now = new Date().getTime();
    const countDownDate = new Date(endDate).getTime();

    const distance = countDownDate - now;

    if (distance < 1000) return "00:00:00";

    const hours = Math.floor(distance / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    return `${padTo2Digits(hours)}:${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`;
};
function padTo2Digits(num: number) {
    return num.toString().padStart(2, "0");
}

export const getContestStatusHeaderText = (contest: Contest | undefined, translate: (str: string, params?: Record<string, any>) => string, title?: string, timeZone?:string) => {
    const statusString = `CONTEST_STATUS_${contest?.status}`;

    switch (contest?.status) {
        case ContestStatus.Incoming:
            return translate(statusString, {
                contestTitle: title,
                date: timeZone ? momentTimeZone.utc(contest?.beginTimestamp).tz(timeZone ?? 'Europe/Rome').format(DEFAULT_FORMAT_DATE) : moment(contest?.beginTimestamp).utcOffset(0).format(DEFAULT_FORMAT_DATE),
            });
        case ContestStatus.Ongoing:
            return translate(statusString, {
                contestTitle: title,
                date: timeZone ? momentTimeZone.utc(contest?.endTimestamp).tz(timeZone ?? 'Europe/Rome').format(DEFAULT_FORMAT_DATE) : moment(contest?.endTimestamp).utcOffset(0).format(DEFAULT_FORMAT_DATE),
            });
        case ContestStatus.Onclosing:
            const timeLeft = getCountdown(contest?.endTimestamp || '');
            return translate(statusString, {
                contestTitle: title,
                timeLeft,
            });
        default:
            return translate(statusString);
    }
};


export function checkIfRenderBadgePoint(contestCosts: Points[] = []): contestCosts is Points[] {
    return !!contestCosts.length && contestCosts.every(c => !c.referredEventId)
}

export function getContestComminucationText(contest: ContestDetailResponse,  translate: (str: string, params?: Record<string, any>) => string, timeZone?:string) {
    return ({
        text: getContestStatusHeaderText(contest.contest, translate, contest.contestCms?.title, timeZone),
        ...getContestStatusColor(contest.contest?.status, translate)
    })
}